
import { Component, Vue } from 'vue-property-decorator';
import { UsersApi, User } from 'performo-api';

@Component({
  components: {}
})
export default class MyProfile extends Vue {
  // user profile vuemodel
  private api = new UsersApi(this.$store.getters.getApiConfiguration);

  get currentUserName(): string {
    return this.user &&
      this.user.contact &&
      this.user.contact.firstName &&
      this.user.contact.lastName
      ? this.user.contact.firstName + ' ' + this.user.contact.lastName
      : this.$store.getters.userDisplayName;
  }

  private user: User = { contact: {} };

  private async mounted() {
    this.user = await this.api.getMyProfile();
  }
}
